import React, { PropsWithChildren } from 'react';

import useStyles from './styles';

interface Props {
    title: React.ReactNode;
    className?: string;
}

const Section: React.FC<PropsWithChildren<Props>> = ({ title, className, children }) => {
    const { classes, cx } = useStyles();

    return (
        <section className={cx(classes.root, className)}>
            <span className={classes.title}>{title}</span>
            {children}
        </section>
    );
};

export default Section;
